module.exports = __webpack_public_path__ + "static/media/NvphCovering.e24bdffe.webp";